import { ofType } from 'redux-observable';
import { mergeMap, map, filter } from 'rxjs';
import { AppEpic } from 'src/store';
import { of } from 'rxjs';
import { updateFlowStatus, updateGroupBy, receiveViewDefns } from 'src/components/Subheader/Subheader.slice';
import { fetchProductivityData, receiveViewDefn } from './Productivity.slice';
import { inputIsNotNullOrUndefined, isScopeDefined, isSubheaderLoaded } from 'src/utils/Functions/epicsFunctions';
import {
  ConfDefnComponentType,
  ProductivityComponent,
  maybeGetComponentProps,
} from 'src/services/configuration/codecs/confdefnComponents';
import { getAggBys } from 'src/pages/Hindsighting/StyleColorReview/StyleColorReview.slice';
import { ListDataOptions } from 'src/worker/pivotWorker.types';
import {
  receiveScopeConfig,
  receiveScopeRefreshTrigger,
} from 'src/components/AssortmentScopeSelector/AssortmentScopeSelector.slice';
import { receiveFilterStateAfterSubmission } from 'src/components/FilterPanel/FilterPanel.slice';

export const productivityLoad: AppEpic = (action$, state$) => {
  return action$.pipe(
    ofType(
      receiveScopeRefreshTrigger.type,
      receiveFilterStateAfterSubmission.type,
      receiveViewDefns.type,
      updateFlowStatus.type,
      updateGroupBy.type,
      receiveViewDefn.type,
      receiveScopeConfig.type
    ),
    map(() => maybeGetComponentProps<ProductivityComponent>(state$.value, ConfDefnComponentType.productivity)),
    filter(inputIsNotNullOrUndefined),
    filter(() => isScopeDefined(state$.value.scope) && isSubheaderLoaded(state$.value.subheader)),
    mergeMap(({ defns }) => {
      const flowStatus = state$.value.subheader.flowStatus.join(',');
      const aggBy = getAggBys(state$.value.subheader, undefined, {
        includeBottomLevel: false,
        forceReload: true,
        groupingKeyOverride: 'dataIndex',
      });
      const options: ListDataOptions = { flowStatus, aggBy };

      return of(fetchProductivityData(defns.model, options));
    })
  );
};
